// extracted by mini-css-extract-plugin
export default {"container":"Setup_container__zfMrH","title":"Setup_title__71lsS","stepper":"Setup_stepper__02iNS","body":"Setup_body__3gTh3","description":"Setup_description__h7RSe"};